import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/styles.scss';
import './index.scss';
import './assets/icomoon/style.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Helmet } from 'react-helmet';
import UserAuthService from "./services/user-auth";
import history from "./navigation/history";
import routes from "./navigation/routes";


// let timeout in storage, check for update page // index.tsx
window.addEventListener('load', function () {

    const timeOut: any = localStorage.getItem('timeout')
    //console.log('load', timeOut)
    if(timeOut){
        //console.log('load ll', Date.now() - timeOut)
        if(Date.now() - timeOut  > 5000){
            localStorage.removeItem('timeout');
            UserAuthService.logout();
            history.push(routes.LOGOUT, {});
        }else{
            localStorage.removeItem('timeout');
        }
    }
})
ReactDOM.render(
    <React.StrictMode>
        <Helmet>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0, user-scalable=1.0, minimum-scale=1.0, maximum-scale=1.0"
            />
        </Helmet>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
